import { useStore } from 'effector-react'

import { $totalCountOfTasks, getTasks, tasksListMounted, $tasks } from './model'
import { TasksRequest } from './types'

export const useTasksList = () => {
  const tasks = useStore($tasks)
  const loading = useStore(getTasks.pending)
  const totalCountOfTasks = useStore($totalCountOfTasks)

  const onChangeTasksList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: TasksRequest) => {
    tasksListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  return {
    tasks,
    totalCountOfTasks,
    loading,
    onChangeTasksList,
  }
}
